"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.State = void 0;
var State;
(function (State) {
    State[State["StartOfLocalPart"] = 0] = "StartOfLocalPart";
    State[State["InQuote"] = 1] = "InQuote";
    State[State["AfterQuote"] = 2] = "AfterQuote";
    State[State["AfterDot"] = 3] = "AfterDot";
    State[State["AfterBackslash"] = 4] = "AfterBackslash";
    State[State["OutsideQuote"] = 5] = "OutsideQuote";
    State[State["StartOfDomain"] = 6] = "StartOfDomain";
    State[State["InIpv4Address"] = 7] = "InIpv4Address";
    State[State["InIpv6Address"] = 8] = "InIpv6Address";
    State[State["InHostname"] = 9] = "InHostname";
    State[State["HostnameAfterDot"] = 10] = "HostnameAfterDot";
    State[State["HostnameAfterHyphen"] = 11] = "HostnameAfterHyphen";
    State[State["EndOfDomain"] = 12] = "EndOfDomain";
    State[State["Error"] = 13] = "Error";
})(State || (exports.State = State = {}));
//# sourceMappingURL=state.js.map